module.exports = __webpack_public_path__ + "assets/2b.png";


//////////////////
// WEBPACK FOOTER
// ./images/2b.png
// module id = 696
// module chunks = 0